::ng-deep lib-detail-user .pos-relative{min-height:100%}
/*# sourceMappingURL=detail-user.component-FENN2NLO.css.map */
